<template>
  <div class="dn-report-main">
    <Input textAlign="center" placeholder="Delivery Note" :inputValue.sync="dnno" @enter="pdfClicked"/>
    <button @click="pdfClicked">Generate Report</button>
    <Loader :isVisible.sync="loading" :loadingText="loadText" :isFullScreen="true" />
    <div class="error-message">{{ errorMessage }}</div>
    <iframe v-if="pdfLink" :src="pdfLink" id="iframe" frameborder="0"></iframe>
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import Input from '@/components/Input.vue';
import Axios from 'axios';

export default {
  components: {
    Loader, Input
  },
  props: {
    dnno: { type: String, default: 'DI/2019/000001' },
    loading: { type: Boolean, default: false },
    loadText: { type: String, default: '' },
    errorMessage: { type: String, default: '' },

    config: { type: String, default: 'dsm6g' },
    userID: { type: String, default: 'Azizi6g' },

    pdfLink: { type: String, default: '' },
  },
  methods: {
    pdfClicked: async function() {
      this.errorMessage = '';
      if (!this.dnno) {
        this.errorMessage = 'Please enter your Delivery Note';
        return;
      }

      this.loading = true;
      this.loadText = 'Getting Report Details';
      var dnDetails = await this.$apiCallV2(`/Report/GetDeliveryNoteDetails?config=${this.config}&userID=${this.userID}&dnno=${this.dnno}`);
      if (!dnDetails) {
        console.log('Please check your config code');
        this.loading = false;
        return;
      }

      if (dnDetails.length == 0) {
        this.loading = false;
        this.errorMessage = `Invalid Delivery Note '${this.dnno}'.\nPlease enter a valid Delivery Note`;
        return;
      }

      let headerDetails = await this.$apiCallV2(`/Report/GetDNHeaderDetailsFromConfig?configcode=${this.config}`);

      dnDetails[0]['ROTDate'] = this.convertDate(dnDetails[0]['ROTDate'], 'dd/MM/yy');
      dnDetails[0]['Date_ETA'] = this.convertDate(dnDetails[0]['Date_ETA'], 'dd/MM/yy');
      dnDetails[0]['companyHeader'] = headerDetails[0]['CoHeaderOpr'] || '';
      
      try {
        this.loading = true;
        this.loadText = 'Creating Report';

        let headerInfo = {
          'Content-Type': 'application/json',
          'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
        };

        var jsReportPDF = await Axios.post('https://dsm.logistics.systems:5488/api/report', {
          template: { shortid: 'BJl6F_jNVD' },
          data: dnDetails[0],
          options: { 'Content-Disposition': 'attachment;filename=report.pdf' }
        }, {
          headers: headerInfo,
          responseType: 'arraybuffer',
        });
        
        this.loading = false;

        var contentType = jsReportPDF.headers['content-type'];
        var blob = new Blob([ jsReportPDF.data ], { type: contentType });
        console.log(blob);
        var url = window.URL.createObjectURL(blob, { oneTimeOnly: false });
        console.log(url);
        var link = document.createElement('a');
        link.href = url;
        this.pdfLink = url;

        setTimeout(() => {
          var frame = document.getElementById('iframe').contentWindow;
          frame.focus();
          frame.print();
        }, 100);

      } catch(error) {
        console.log(error);
        this.loading = false;
        this.errorMessage = 'There was an error while creating your report';
      }
    },
    convertDate: function(dateString, format) {
      if (!dateString) {
        return "";
      }

      let dateObj;

      if (dateString.includes('Date')) {
        var dateMilli = dateString;
        dateMilli = dateMilli.split('/').join('');
        dateMilli = dateMilli.split('(').join('');
        dateMilli = dateMilli.split(')').join('');
        dateMilli = dateMilli.split('Date').join('');
        dateObj = new Date(Number(dateMilli));
      } else {
        dateObj = new Date(dateString);
      }

      return this.$dateTime.getDateTime(dateObj, format);
    }
  },
  async mounted() {
    this.userID = this.$route.params.userID;
    this.config = this.$route.params.config;
    this.dnno = this.$route.params.dnno;

    if (this.userID && this.config && this.dnno) {
      this.pdfClicked();
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
@import '@/css/all.scss';

.dn-report-main {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > iframe {
    width: 100%;
    height: 100%;
  }

  > .error-message {
    color: red;
    width: 100%;
    text-align: center;
    margin-top: 5px;
    white-space: pre-wrap;
  }
}
</style>